// Screen that tells the user that there are no recommended comps available for the subject.
import { Button, Flex, Typography } from '@aloft/toolkit-sui';

export const NoRecommendationsAvailable = ({
  body,
  getProperties,
}: {
  body: { status: 'not_found' } | { status: 'error'; message: string };
  getProperties: () => void;
}) => {
  const isError = body.status === 'error';

  return (
    <Flex
      flexDirection="column"
      alignItems="center"
      gap="5rem"
      justifyContent="center"
      height="100%"
    >
      <Flex flexDirection="column" gap="1rem" alignItems="center">
        <Typography variant="h2">
          {isError ? 'Recommended Comps Not Available' : 'No Recommended Comps Found'}
        </Typography>
        <Typography variant="body1">
          {isError
            ? 'An error occurred, no recommended comps are available for your subject property.'
            : "We couldn't find any recommended comps for this property. Try adjusting your filters, or manually add comparables above."}
        </Typography>
        {!isError && (
          <Typography variant="body1">
            If you applied new filters, try removing or loosening them, or manually adding
            comparables above.
          </Typography>
        )}
        {isError && (
          <Typography variant="body1" color="error">
            {body.message}
          </Typography>
        )}
        {isError && <Button text="Retry" onClick={getProperties} />}
      </Flex>
    </Flex>
  );
};
